const enum FileType {
    CNS = "CNS",
    NATUS = "Natus",
    MEDICATIONS = "Medications",
    EDF = "EDF"
}

export default FileType